export const GET_AUTHORIZATION_PENDING = '[Authorization]/GET_AUTHORIZATION_PENDING';

export const GET_AUTHORIZATION_SUCCESS = '[Authorization]/GET_AUTHORIZATION_SUCCESS';

export const GET_AUTHORIZATION_ERROR = '[Authorization]/GET_AUTHORIZATION_ERROR';

export const SET_USER_GROUPS_PENDING = '[Core]/SET_USER_GROUPS_PENDING';
export const SET_USER_GROUPS_SUCCESS = '[Core]/SET_USER_GROUPS_SUCCESS';
export const SET_USER_GROUPS_ERROR = '[Core]/SET_USER_GROUPS_ERROR';
